/**
 * Copyright (c) 2024, King Living
 * @override - King Living login fields with "Email address" label (sentence case)
 * and enhanced email validation via validateEmail.
 *
 * Validation Rules:
 * - Email: Valid format, character limit
 */

import {useIntl} from 'react-intl';

import {FIELD_LIMITS, validateEmail} from '@amblique/king-living/app/utils/validation';

export default function useLoginFields({
  form: {
    control,
    formState: {errors},
  },
  prefix = '',
}) {
  const {formatMessage} = useIntl();

  const fields = {
    email: {
      name: `${prefix}email`,
      label: formatMessage({
        defaultMessage: 'Email address',
        id: 'use_login_fields.label.email',
      }),
      type: 'email',
      autoComplete: 'email',
      defaultValue: '',
      rules: {
        required: formatMessage({
          defaultMessage: 'Please enter your email address.',
          id: 'use_login_fields.error.required_email',
        }),
        validate: (value) => validateEmail(value, {
          maxLength: FIELD_LIMITS.email,
          formatMessage,
        }),
      },
      inputProps: {
        maxLength: FIELD_LIMITS.email,
      },
      error: errors?.[`${prefix}email`],
      control,
    },
    password: {
      name: `${prefix}password`,
      label: formatMessage({
        defaultMessage: 'Password',
        id: 'use_login_fields.label.password',
      }),
      type: 'password',
      autoComplete: 'current-password',
      defaultValue: '',
      rules: {
        required: formatMessage({
          defaultMessage: 'Please enter your password.',
          id: 'use_login_fields.error.required_password',
        }),
      },
      error: errors?.[`${prefix}password`],
      control,
    },
  };

  return fields;
}
